import en from './locales/en.json';

export type TranslationKey = keyof typeof en;

const translations = {
  en,
};

type Locale = keyof typeof translations;

let currentLocale: Locale = 'en';

export function getTranslationFor(key: TranslationKey): string {
  return translations[currentLocale][key];
}

export function setLocale(locale: Locale): void {
  currentLocale = locale;
}

export function getCurrentLocale(): Locale {
  return currentLocale;
}
